import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    blogs: [],
    selectedBlog: null,
    loading: false
};

const blogSlice = createSlice({
    name: "blog",
    initialState,
    reducers: {
        setBlogs: (state, action) => {
            state.blogs = action.payload;
        },

        setSelectedBlog: (state, action) => {
            state.selectedBlog = action.payload;
        },

        setLoading: (state, action) => {
            state.loading = action.payload;
        },

        addBlog: (state, action) => {
            state.blogs.unshift(action.payload);
        },

        updateBlog: (state, action) => {
            const index = state.blogs.findIndex(
                blog => blog._id === action.payload._id
            );

            if (index !== -1) {
                state.blogs[index] = action.payload;
            }
        },

        removeBlog: (state, action) => {
            state.blogs = state.blogs.filter(
                blog => blog._id !== action.payload
            );
        }
    }
});

export const {
    setBlogs,
    setSelectedBlog,
    setLoading,
    addBlog,
    updateBlog,
    removeBlog
} = blogSlice.actions;

export const BlogReducer = blogSlice.reducer;